import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/lib/UI/loadingSpinner/LoadingSpinner';
import { useAppSelector } from 'setup/store';
import { useParams } from 'react-router-dom';
import UserDataForm from 'components/user/user-data-form/UserDataForm';
import { Box } from '@mui/material';

const UserDetailsPage = () => {
  const { t } = useTranslation();
  const params = useParams();
  const userId = params && params.userId ? params.userId : undefined;
  const loading = useAppSelector((store) => store.userReducer.loading);

  return (
    <section style={{ marginBottom: '80px' }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle">{t('page.userDetails')}</h2>
      </Box>
      {loading ? <LoadingSpinner /> : null}
      <UserDataForm userId={userId} />
    </section>
  );
};

export default UserDetailsPage;
